// src/components/Header.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';  // Import useNavigate
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useMediaQuery } from '@mui/material';

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:767px)');

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  //   navigate('/vehicles/cars');  // Navigate to /vehicles/cars when menu closes
  // };

  return (
    <AppBar position="fixed" width="100%">
      <Toolbar>
      <img src={`${process.env.PUBLIC_URL}/logo.jpeg`} alt="logo"
      style={{
        height: '30px',
        width:'30px',
        marginRight: '10px',
        borderRadius: '50%',
        objectFit: 'cover',
        transform: 'scale(1.2)'
      }} />
        <Typography variant="h6" component="h1" sx={{ flexGrow: 1 }}>
          The Rentalz By Tripping Company
        </Typography>
        {isMobile ? (
          <>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleMenuClick}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}  // Close menu without navigation
              disableScrollLock={true}
            >
              <MenuItem color="inherit" onClick={() => navigate('/')}>Home</MenuItem>
              <MenuItem color="inherit" onClick={() => navigate('/vehicles/cars')}>Cars</MenuItem>
              <MenuItem onClick={() => navigate('/vehicles/scooties')}>Scooties</MenuItem>
              <MenuItem color="inherit" onClick={() => navigate('/contact')}>Contact</MenuItem>
            </Menu>
          </>
        ) : (
          <Box>
            <Button color="inherit" onClick={() => navigate('/')}>Home</Button>
            <Button color="inherit" onClick={() => navigate('/vehicles/cars')}>Cars</Button>
            <Button color="inherit" onClick={() => navigate('/vehicles/scooties')}>Scooties</Button>
            <Button color="inherit" onClick={() => navigate('/contact')}>Contact</Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
